import { Plus } from "@procore/core-icons";
import {
   Button,
   Card,
   H2,
   spacing,
   Spinner,
   TextInput,
   Title,
   useI18nContext,
} from "@procore/core-react";
import React, { useEffect, useState } from "react";
import { CategoryList } from "./category-list";
import type { ActiveRow } from "./types";
import { useCategories } from "./useCategories";
import { CATEGORIES_TRANSLATIONS } from "./utils";

export const CategoriesCard = ({ projectId }: { projectId: string }) => {
   const I18n = useI18nContext();
   const {
      categories,
      isLoading,
      create,
      rename,
      remove,
      move,
      isDeleting,
      isCreating,
      isRenaming,
      isMoving,
   } = useCategories(projectId, {
      onSuccess: () => setActiveRow(null),
   });
   const [activeRow, setActiveRow] = useState<ActiveRow | null>(null);
   const [showSubcategories, setShowSubcategories] = useState(true);
   const [search, setSearch] = useState("");

   const hasSubcategories = categories.some((c) => c.parent_id !== null);

   useEffect(() => {
      if (categories.length === 0) setSearch("");
   }, [categories.length]);

   return (
      <Card style={{ padding: spacing.md, width: "100%" }}>
         <Spinner loading={isLoading}>
            <Title style={{ paddingBottom: spacing.md }}>
               <Title.Text>
                  <H2>{I18n.t(`${CATEGORIES_TRANSLATIONS}.title`)}</H2>
               </Title.Text>
               <Title.Actions>
                  {categories.length > 0 && (
                     <>
                        {hasSubcategories && (
                           <Button
                              variant="secondary"
                              disabled={!!search}
                              onClick={() => setShowSubcategories((prev) => !prev)}
                           >
                              {I18n.t(
                                 `${CATEGORIES_TRANSLATIONS}.${
                                    showSubcategories ? "hide_subcategories" : "show_subcategories"
                                 }`,
                              )}
                           </Button>
                        )}
                        <Button
                           variant="secondary"
                           disabled={!!search}
                           icon={<Plus />}
                           onClick={() =>
                              setActiveRow({ id: null, mode: "create", parentId: null })
                           }
                        >
                           {I18n.t(`${CATEGORIES_TRANSLATIONS}.add_category`)}
                        </Button>
                     </>
                  )}
               </Title.Actions>
            </Title>
            {categories.length > 0 && (
               <TextInput
                  name="search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder={I18n.t(`${CATEGORIES_TRANSLATIONS}.search_placeholder`)}
                  style={{ marginBottom: spacing.sm }}
               />
            )}
            <CategoryList
               categories={categories}
               activeRow={activeRow}
               setActiveRow={setActiveRow}
               showSubcategories={showSubcategories}
               search={search}
               onCreate={(params) => create(params)}
               onRename={(params) => rename(params)}
               onDelete={(params) => remove(params)}
               onMove={(update) => move(update)}
               isDeleting={isDeleting}
               isCreating={isCreating}
               isRenaming={isRenaming}
               isMoving={isMoving}
            />
         </Spinner>
      </Card>
   );
};
